import PropTypes from 'prop-types';
import React from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { getLandingPath } from '../../services/landingPath';

const SecurityRoute = ({
    component: Component,
    routeType: Route,
    withHeader,
    withFooter,
    isAuthenticated,
    landingPath,
    ...rest
}) => (
    <Route
        {...rest}
        render={(props) =>
            isAuthenticated === false ? (
                <Component {...props} />
            ) : (
                <Redirect exact to={landingPath} />
            )
        }
    />
);

const mapStateToProps = (state) => {
    return {
        isAuthenticated: !!state.security.access_token,
        // The post-authentication saga pushes the same path, but this redirect
        // renders first on the password flow — see services/landingPath.
        landingPath: getLandingPath(state.userDetails.data),
    };
};

SecurityRoute.propTypes = {
    isAuthenticated: PropTypes.bool,
    landingPath: PropTypes.string,
    withFooter: PropTypes.bool,
    withHeader: PropTypes.bool,
};

export default connect(mapStateToProps, null)(SecurityRoute);
